(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    var tagManagement = require('../modules/utils/tag_management.utils');
    const resetPasswordManagerFactory = require('components/user_area/reset_password_manager/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');

    Odigeo.Router.handlers.resetpassword = function(resetPassCode) {
        const widgetLoader = createWidgetLoader({
            resetPassword: ['reset-password', resetPasswordManagerFactory],
        });
        var page = 'resetpassword';

        $('#page').removeClass().addClass(page);

        Odigeo.Session.set('page', 'resetpassword');

        Odigeo.Router.eventController = $.extend(Odigeo.Router.eventController, Odigeo.Router.handlers.userEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, Odigeo.Router.handlers.globalEventController, {
            // Global events will remain bound in any part of the application
            globalEvents: {},
            // View or local events which are triggered from this view.
            // They will be unbinded when the view changes.
            viewEvents: {
                'reset-password:submitUserRequest': 'onSubmitUserRequest',
                /** Reset Password */
                'users-manager:changePasswordWithCodeOk': 'onChangePasswordSuccess',
                'users-manager:changePasswordWithCodeWithError': 'onChangePasswordWithError',
                'users-manager:changePasswordWithCodeError': 'onChangePasswordError',
            },
            // implementation of events handlers
            eventHandlers: {
                onChangePasswordSuccess: function(data) {
                    widgetLoader.get('resetPassword').execute('passwordChangedOk', data);
                },

                onChangePasswordWithError: function(data) {
                    widgetLoader.get('resetPassword').execute('passwordWithError', data);
                },

                onChangePasswordError: function(data) {
                    widgetLoader.get('resetPassword').execute('passwordError', data);
                },

                onSubmitUserRequest: function(data) {
                    Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
                        usersmanager.execute('submitUserRequest', data);
                    });
                },
            },
        });

        Odigeo.Router.eventController.execute();

        widgetLoader.get('resetPassword').execute('setRecoverCode', resetPassCode);

        // Analytics: virtual page tracking
        trackingUtils.trackPage('password_change', {
            funnel: false,
        });
        tagManagement.updateDatalayer();

        Odigeo.Utils.sessionTimer.reset();
    };
}());
